module.exports = __webpack_public_path__ + "static/media/JM.c7c5e396.svg";